import React from 'react';

const Categories = () => <h1>Under construction</h1>;

export default Categories;
